// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  ReferralOptionsDiv,
  ReferralOptionsBackgroundDiv,
  ReferralOptionsContainerDiv,
  ReferralOptionItemDiv
} from './ReferralOptionsStyles';
import ReferralOption from './ReferralOption';
import { BlueStyledLink, LinkIconDiv } from '../../../components/LinkStyles';
import { DefaultIcon } from '../../../components/Icon';

type Props = {
  referralUrl: string,
  partnerReferralUrl: string,
  flippers: {
    partner_referrals: boolean
  }
};

class ReferralOptions extends Component<Props> {
  render() {
    return (
      <ReferralOptionsBackgroundDiv>
        <ReferralOptionsDiv>
          <ReferralOptionsContainerDiv>
            <ReferralOptionItemDiv>
              <ReferralOption
                mainTitle="Direct Merchant"
                title="Referral Link"
                text="Share this link with your direct merchants to register for a cryptocurrency account through Netcents. Once they create an account you will be able to track their progress and transactions from your dashboard."
                icon="merchant"
                iconSize="2rem"
                copyableUrl={this.props.referralUrl}
                linkText="Copy Merchant Link"
                linkTo="/merchants/registrations/form/1"
              />
              <LinkIconDiv>
                <BlueStyledLink to="/merchants/registrations">
                  {' '}
                  View more ways to refer direct merchants
                </BlueStyledLink>
                <DefaultIcon
                  name="chevronRight"
                  iconSize="1rem"
                  colorName="blue"
                />
              </LinkIconDiv>
            </ReferralOptionItemDiv>
            {this.props.flippers.partner_referrals && (
              <ReferralOptionItemDiv>
                <ReferralOption
                  mainTitle="Partner"
                  title="Referral Link"
                  text="Share this link with your preferred partners and have them register for a NetCents Partner account. Once they create an account you will be able to track their progress and merchant referrals from your dashboard."
                  icon="partners"
                  iconSize="2rem"
                  copyableUrl={this.props.partnerReferralUrl}
                  linkText="Copy Partner Link"
                  linkTo="/merchants/registrations/form/1"
                />
                <LinkIconDiv>
                  <BlueStyledLink to="/partners/referred">
                    {' '}
                    View Referred Partners
                  </BlueStyledLink>
                  <DefaultIcon
                    name="chevronRight"
                    iconSize="1rem"
                    colorName="blue"
                  />
                </LinkIconDiv>
              </ReferralOptionItemDiv>
            )}
          </ReferralOptionsContainerDiv>
        </ReferralOptionsDiv>
      </ReferralOptionsBackgroundDiv>
    );
  }
}

const mapStateToProps = state => ({
  referralUrl: state.global.referralDetails.referral_link,
  partnerReferralUrl: state.global.referralDetails.partner_referral_link,
  flippers: state.global.flippers
});

export default connect(mapStateToProps)(ReferralOptions);
